// client/src/components/promoters/PromoterJoin.jsx
//
// /:tenant/promoter/join?token=… — the magic link in a promoter's invite
// email. Exchanges the single-use token for a member session, then opens the
// promoter page. Growth Phase 2, feature_key "promoters".

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Promoters.css';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

export default function PromoterJoin() {
  const { t } = useTranslation();
  const { tenant } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState('working'); // working | expired | emailInUse | error
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return; // StrictMode double-mount: the token works once
    started.current = true;
    const token = new URLSearchParams(search).get('token');
    if (!token) { setState('expired'); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${BASE_URL}/api/promoters/invite/redeem`, { token }, { withCredentials: true });
        try { if (data.token) localStorage.setItem('memberToken', data.token); } catch { /* cookie is enough */ }
        navigate(`/${data.tenantId || tenant}/promoter`, { replace: true });
      } catch (err) {
        const code = err?.response?.data?.code;
        setState(code === 'EMAIL_IN_USE' ? 'emailInUse' : err?.response?.status === 410 || err?.response?.status === 400 ? 'expired' : 'error');
      }
    })();
  }, [search, tenant, navigate]);

  return (
    <div className="pp-page">
      {state === 'working' && <div className="surface">{t('promoterJoin.working', 'Opening your promoter page…')}</div>}
      {state === 'expired' && (
        <div className="surface">
          <p>{t('promoterJoin.expired', 'This invite link has expired or was already used. Ask the organizer to send a new one, or sign in if you already have an account.')}</p>
          <button type="button" className="pp-btn" onClick={() => navigate(`/${tenant}/memberLogin`)}>
            {t('promoterPortal.signInButton', 'Member sign in')}
          </button>
        </div>
      )}
      {state === 'emailInUse' && (
        <div className="note warn">{t('promoterJoin.emailInUse', 'Your email already has a member account with another organization, so it can’t be used here. Ask the organizer to invite a different email address.')}</div>
      )}
      {state === 'error' && <div className="note error">{t('promoterJoin.error', 'Something went wrong. Try the link again in a minute.')}</div>}
    </div>
  );
}
